// extracted by mini-css-extract-plugin
export default {"fs":"_976098d894 b31e75f7bc"};